import { tsStudyAttribute } from '../../../Typescript/StuartPy/StudyAttribute'
import { validForm } from './FormulaRegexCreate'

export function OBJtoUI(
  obj: tsStudyAttribute,
  idToName: { [key: string]: string },
  type: 'new' | 'hist',
) {
  if (type === 'new') {
    return `${obj.AttrName}`
  } else {
    return `${idToName[obj.PhaseID]}: ${obj.AttrName}`
  }
}

export function OBJtoDB(obj: tsStudyAttribute, type: 'new' | 'hist') {
  const dbVal = `U%UAI%P${obj.PhaseID}A${obj.AttrID}`
  if (type === 'new') {
    return `new${dbVal}`
  } else {
    return `${dbVal}`
  }
}

export function UItoDB(uiValue: string, map: { [key: string]: string }) {
  const pattern = /{(?:[A-z0-9\s]+: )?[^{}]+}/g
  const matches = uiValue.matchAll(pattern)
  let dbValue = uiValue
  for (const match of matches) {
    if (Object.keys(map).includes(match[0].substring(1, match[0].length - 1))) {
      dbValue = dbValue.replace(
        match[0],
        map[match[0].substring(1, match[0].length - 1)],
      )
    }
  }
  return dbValue.replaceAll(' ', '')
}

export function DBtoUI(dbValue: string, map: { [key: string]: string }) {
  const pattern = /(?:new)?U%UAI%P[a-f0-9]+A[0-9]+/g
  const matches = dbValue.matchAll(pattern)
  let uiValue = dbValue
  for (const match of matches) {
    uiValue = uiValue.replace(match[0], ` {${map[match[0]]}} `)
  }
  return uiValue
}

// input is array of matched bracket chars
export const isBalanced = (s: RegExpMatchArray | null) => {
  if (s === null) return true
  if (s.length % 2 !== 0) return false

  const stack: (string | undefined)[] = []
  const map = new Map([
    ['(', ')'],
    ['[', ']'],
    ['{', '}'],
  ])

  for (let i = 0; i < s.length; i += 1) {
    if (map.has(s[i])) {
      stack.push(map.get(s[i]))
    } else if (s[i] !== stack.pop()) {
      return false
    }
  }
  return stack.length === 0
}

export function validateFormula(
  uiValue: string,
  dbValue: string,
  formulaType: 'END' | 'CAL',
) {
  // console.group('regex')
  // console.log('rangeCalc', rangeCalc)
  // console.log('anyValue', anyValue)
  // console.log('anyWrappedVal', anyWrappedVal)
  // console.log('opPlusVal', opPlusVal)
  // console.log('validForm', validForm)
  // console.groupEnd()

  if (uiValue.length < 2 || !uiValue.startsWith('=')) {
    //at least 1 char after '='
    return "Formula must start with an '=' and return a value"
  } else if (!isBalanced(dbValue.match(/[()[\]{}]/g))) {
    return 'Brackets or braces are not balanced'
  } else if (dbValue.includes('undefined')) {
    return 'An attribute does not match a valid option above'
  } else if (
    formulaType === 'END' &&
    (uiValue.match(/[<>]/g) || []).length < 1
  ) {
    return 'An Endpoint formula must resolve to a TRUE or FALSE (use >, <, =, <=, or >=)'
  } else if (
    formulaType === 'CAL' &&
    (uiValue.match(/[<>]/g) || []).length > 0
  ) {
    return 'A Calculation formula must resolve to number (not a TRUE or FALSE)'
  } else if (!validForm.test(uiValue)) {
    return 'A math operator must be used once between variables AND Historic Attributes must be wrapped by a function e.g. MAX(...)'
  }
  return ''
}
